module.exports = __webpack_public_path__ + "static/media/img1-2.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/nutricheck_foliar/P/img1-2.png
// module id = 2064
// module chunks = 3